import './plugins/vuetify'
import './plugins/vue_string_filter'
import './plugins/smoot_picker'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'
import './assets/stylesheets/global_custom_style.scss'
import { ApolloProvider } from './apollo-provider'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

if (process.env.NODE_ENV === "production"){
  Sentry.init({
    dsn: 'https://7751205a22af45639b5ef5d5a1158fb1@sentry.archimedianet.it/22',
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
    release: process.env.VUE_APP_VERSION,
    environment: process.env.NODE_ENV
  });

}


Vue.config.productionTip = false

new Vue({
  router,
  apolloProvider: ApolloProvider,
  render: h => h(App)
}).$mount('#app')

